export const regimensData = [
  { "value": "601", "label": "601 - Régimen general de ley personas morales" },
  { "value": "603", "label": "603 - Personas morales con fines no lucrativos" },
  { "value": "605", "label": "605 - Régimen de sueldos y salarios e ingresos asimilados a salarios" },
  { "value": "606", "label": "606 - Régimen de arrendamiento" },
  { "value": "607", "label": "607 - Régimen de enajenación o adquisición de bienes" },
  { "value": "608", "label": "608 - Régimen de los demás ingresos" },
  { "value": "609", "label": "609 - Régimen de consolidación" },
  { "value": "610", "label": "610 - Régimen residentes en el extranjero sin establecimiento permanente en México" },
  { "value": "611", "label": "611 - Régimen de ingresos por dividendos (socios y accionistas)" },
  { "value": "612", "label": "612 - Régimen de las personas físicas con actividades empresariales y profesionales" },
  { "value": "614", "label": "614 - Ingresos por intereses" },
  { "value": "615", "label": "615 - Ingresos por Régimen de los ingresos por obtención de premios" },
  { "value": "616", "label": "616 - Sin obligaciones fiscales" },
  { "value": "620", "label": "620 - Sociedades Cooperativas de Producción que optan por diferir sus ingresos" },
  { "value": "621", "label": "621 - Incorporación Fiscal" },
  { "value": "622", "label": "622 - Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras" },
  { "value": "623", "label": "623 - Opcional para Grupos de Sociedades" },
  { "value": "624", "label": "624 - Coordinados" },
  { "value": "625", "label": "625 - Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas" },
  { "value": "626", "label": "626 - Régimen Simplificado de Confianza" },
];
